import React from "react";
import { gql } from "@apollo/client";
import { Instrument, InstrumentType } from "@syos-music/instruments";

export default function MouthpieceLabel({ mouthpieceRef, ...props }) {
  return (
    <span {...props}>
      <Instrument instrument={mouthpieceRef?.instrument} />{" "}
      <InstrumentType
        instrument={mouthpieceRef?.instrument}
        instrumentType={mouthpieceRef?.instrumentType}
        lowercase
      />
      {!!mouthpieceRef?.name && " - " + mouthpieceRef.name}
    </span>
  );
}

MouthpieceLabel.fragments = {
  mouthpieceRef: gql`
    fragment MouthpieceLabel_mouthpieceRef on MouthpieceRef {
      id
      instrument
      instrumentType
      name
    }
  `,
};
